import React from "react";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import { useClaims } from "../../../../../auth/ClaimsProvider";

const projectsItProjects: string = "/projects";
const projectsRoadmaps: string = "/roadmaps";

export function useGetProjectNavItems() {
  const { hasPermission } = useClaims();

  const hasItProjectsReadPermission = hasPermission(
    ShiOnePermission.itProjectsRead,
  );
  const showShiOneProjectsLink = hasItProjectsReadPermission;

  const hasRoadmapsPermission = hasPermission(ShiOnePermission.roadmapsManage);

  const showRoadmapsLink = Boolean(hasRoadmapsPermission);
  const showProjectsSection = showRoadmapsLink || showShiOneProjectsLink;
  return [
    {
      id: "projects",
      type: "Group",
      displayName: "Project Management",
      visible: showProjectsSection,
      icon: <WorkOutlineIcon />,
      children: [
        {
          id: "projects-it-projects",
          type: "Link",
          displayName: "Projects",
          visible: showShiOneProjectsLink,
          path: projectsItProjects,
        },
        {
          id: "projects-roadmaps",
          type: "Link",
          displayName: "Roadmaps",
          visible: showRoadmapsLink,
          path: projectsRoadmaps,
        },
      ],
    },
  ];
}
